import { useAuthContext } from '../../../contexts/AuthContext';

// Guards routes that must be restricted to VDcontrol users only.
export const ControlRoute = ({ children }) => {
  const { tags, authReady, logout } = useAuthContext();

  // Wait until localStorage hydration is done before checking anything.
  if (!authReady) return null;

  if (Array.isArray(tags) && tags.includes('VDcontrol')) return children;

  const handleBackToLogin = async (e) => {
    e.preventDefault();
    await logout();
    window.location.href = '/';
  };

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', height: '100vh', gap: '16px',
      background: '#0a0a0a', color: '#fff', fontFamily: 'sans-serif'
    }}>
      <div style={{ fontSize: '52px' }}>⛔</div>
      <div style={{ fontSize: '22px', fontWeight: 700 }}>Access Denied</div>
      <div style={{ fontSize: '14px', color: '#888' }}>
        Your account does not have permission to access this page.
      </div>
      <a href="/" onClick={handleBackToLogin} style={{
        marginTop: '12px', padding: '10px 24px', borderRadius: '8px',
        background: '#86BC25', color: '#fff', textDecoration: 'none',
        fontWeight: 700, fontSize: '14px'
      }}>
        ← Back to Login
      </a>
    </div>
  );
};
